/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
require('./main');
require('./custom');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

// Vue.component('example', require('./components/Example.vue'));


$(document).ready(function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        }
    });



    if (document.getElementById('domain-form')) {
        new Vue({
            el: '#domain-form',
            data: {
                url: '',
                domain: '',
                extention: '',
                route: '',
                routeForAll: '',
                loading: false,
                loadMore: false,
            },
            mounted: function () {

                console.log(this.$el);

                this.route = this.$el.getAttribute('data-route');
                this.routeForAll = this.$el.getAttribute('data-all');
            },
            watch: {
                url: function (value) {
                    this.makeValidDomain();
                }
            },

            methods: {
                checkDomain: _.debounce(function () {
                    this.getDomains();
                }, 500),

                getDomains: function () {
                    this.loading = true;
                    let that = this;
                    $.post(this.route, {domain: this.domain, extention: this.extention}, function (data) {
                            $('.card-holder').html(data);
                            that.loading = false;
                            that.loadMore = true;
                        }
                    );
                },

                getAllDomains: function () {
                    this.loading = true;
                    this.loadMore = false;
                    let that = this;
                    $.post(this.routeForAll, {domain: this.domain, extention: this.extention}, function (data) {
                            $('.card-holder').html(data);
                            that.loading = false;
                        }
                    );
                },

                makeValidDomain: function () {
                    let segments = this.url.split('.');
                    let domain = segments[0];
                    let extention = this.extention;
                    if (segments.hasOwnProperty(1)) {
                        extention = segments[1];
                        this.extention = extention;
                    } else {
                        this.extention = '';
                    }

                    domain = domain.toString().toLowerCase()
                        .replace(/\s+/g, '-')           // Replace spaces with -
                        .replace(/&/g, '-en-')          // Replace & with 'and'
                        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                        .replace(/\-\-+/g, '-');        // Replace multiple - with single -

                    this.domain = domain;
                }
            }
        });
    }

    
});
